export default class ProviderEvents {
  constructor (provider, setFeatureState) {
    this.provider = provider;
    this.existingProviders = ['SYNOT', 'ENDORPHINA', 'TECH4BET', 'PLAYNGO', 'YGGDRASIL', 'NOVOMATIC', 'APOLLOGAMES'];
    this.isSupported = this.existingProviders.includes(provider);
    this.setFeatureState = setFeatureState;
    this.isSupported && this.enableEventListener();
    this.featureNames = { startFeatureNames: '', endFeatureNames: '' }
  }

  enableEventListener () {
    window.addEventListener('message', this.featureStateManager.bind(this), false);
  }

  featureStateManager (e) {
    const featureState = this[`${this.provider}Event`](e);
    (featureState !== 'NOT_EVENT') && this.setFeatureState(featureState);
  }

  SYNOTEvent (e) {
    const event = e.data.event;
    if (event === 'g2p.featureStarted') return true;
    if (event === 'g2p.featureFinished') return false;

    return 'NOT_EVENT';
  }

  ENDORPHINAEvent (e) {
    if (!this.featureNames.startFeatureNames) this.featureNames.startFeatureNames = ['Freegames', 'Gamble', 'Bonus'];

    const { messageId, featureName } = e.data;

    const hasEnded = messageId === 'endFeature';
    if (hasEnded) return false;

    const isSpecialFeature = messageId === 'startFeature' && (this.featureNames.startFeatureNames.includes(featureName));
    const isStepFeature = messageId === 'stepFeature';
    const hasStarted = isSpecialFeature || isStepFeature;
    if (hasStarted) return true;

    return 'NOT_EVENT';
  }

  TECH4BETEvent (e) {
    const event = e.data.method;
    if (event === 'game.round.started') return true;
    if (event === 'game.round.ended') return false;

    return 'NOT_EVENT';
  }

  PLAYNGOEvent (e) {
    if (!this.featureNames.startFeatureNames) {
      this.featureNames.startFeatureNames = ['freespinStarted', 'bonusGameStarted', 'gambleStarted'];
      this.featureNames.endFeatureNames = ['freespinEnded', 'bonusGameEnded', 'gambleEnded'];
    }

    const event = e.data.type;

    const isFeatureStarted = this.featureNames.startFeatureNames.includes(event);
    if (isFeatureStarted) return true;

    const isFeatureEnded = this.featureNames.endFeatureNames.includes(event);
    if (isFeatureEnded) return false;

    return 'NOT_EVENT'
  }

  YGGDRASILEvent(e) {
    const event = e.data;
    if (event === 'gameRound/start') return true;
    if (event === 'gameRound/end') return false;

    return 'NOT_EVENT';
  }

  NOVOMATICEvent(e) {
    let event = e.data;
    if (!this.featureNames.startFeatureNames) {
      this.featureNames.startFeatureNames = ['FreeGamesStart']; // Add more events if needed
      this.featureNames.endFeatureNames = ['FreeGamesEnd'];
    }

    try {
      event = JSON.parse(event);
      event = event.state.name;
    } catch {
      return 'NOT_EVENT'
    }

    const isFeatureStarted = this.featureNames.startFeatureNames.includes(event);
    if (isFeatureStarted) return true;

    const isFeatureEnded = this.featureNames.endFeatureNames.includes(event);
    if (isFeatureEnded) return false;

    return 'NOT_EVENT'
  }
}
